import React, { PureComponent, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import CalendarSvg from '../../../shared/UI/calendarSvg';
import CalendarEditSvg from '../../../shared/UI/calendarEditSvg';
import CloseSvg from '../../../shared/UI/closeSvg';
import CheckSvg from '../../../shared/UI/checkSvg';
import { pluralHelper } from '../../../../helpers/stringutils';
import { UpdateSector } from '../../../../actions/booking';
import ReactModal from 'react-modal';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import CalenderPanel from '../../../shared/calender/calender-panel';
import { itineraryListData } from '../../../../helpers/itineraryHelper';
import { GetProduct } from '../../../../actions/product';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import { UpdateProductSector } from '../../../../actions/booking';
import { productData } from '../../../../helpers/productHelper';
import CloseRoundSvg from '../../../shared/UI/closeRoundSvg';
import { GetSectorHotel } from '../../../../actions/hotel';

ReactModal.setAppElement('#root');
dayjs.extend(AdvancedFormat);


class DatesNightsPanel extends PureComponent{

    constructor(props){
        super(props);

        this.state = {
            changeNightVisible:false,
            nights:0,
            nightsTouched:false,
            hasProduct:false,
            showWarningModal:false,
            calenderIsOpen:false
        }

        this.onChangeNight = this.onChangeNight.bind(this);
        this.onNightsChange = this.onNightsChange.bind(this);
        this.onCheckHandler = this.onCheckHandler.bind(this);
        this.onChangeProductDate = this.onChangeProductDate.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal(){ this.setState({showWarningModal:true}); }
    closeModal(){ this.setState({showWarningModal:false}); }


    componentDidMount(){

        const { currentBooking:{ items } } = this.props;

        //check itinerary for any products
        this.setState({hasProduct:items.filter(data => { return data.type === "product"}).length > 0 ? true : false});
    }

    componentWillUnmount(){
        this.setState({showWarningModal:false});
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.currentStop !== prevProps.currentStop){
          this.setState({changeNightVisible:false});
        }
    }

    onChangeNight(){
      
        const { currentStop, currentBooking:{ filteredItinerary } } = this.props;
        const numNights = filteredItinerary[currentStop].nights || 0;

        //Show warning modal   
        if(this.state.hasProduct && this.state.nightsTouched) this.openModal();

        this.setState({
            nights:numNights,
            changeNightVisible: !this.state.changeNightVisible
        });
    }


    onNightsChange(direction){
    
        const { nights } = this.state;
    
        if(direction === 'down'){
          if(nights > 0) this.setState({nights: nights - 1, nightsTouched:true});
        }
        if(direction === 'up'){
          if(nights < 10) this.setState({nights: nights + 1, nightsTouched:true});
        }
    
    }

    onCheckHandler(){
    
        const { currentStop, client, currentBooking:{uuid, filteredItinerary}, isLoading } = this.props;
        const updatedDate = dayjs(filteredItinerary[currentStop].date).add(this.state.nights, 'days').format('YYYY-MM-DD');
        const _sectorId = parseInt(filteredItinerary[currentStop].id, 10);

        if(!isLoading){
         
            UpdateSector(client, uuid, parseInt(filteredItinerary[currentStop].id,10), parseInt(this.state.nights, 10), updatedDate, true).then(()=>{

                this.setState({nightsTouched:false});
                
                GetSectorHotel(client, uuid, _sectorId);
            });
        }
    }

    renderNightComponent(){
        return(
            <div className="inline plus-minus-buttons">
               
                <button type="button" className={`${(this.state.nights === 0) ? "disabled": ""}`} onClick={e => this.onNightsChange('down')}>
                    <span className="down-button"><svg className="nights inline-block" viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg></span>
                </button>

                <span className="pax-number f-size-16 bold">{this.state.nights} {pluralHelper("Night", this.state.nights)}</span>

                <button type="button" className={`${(this.state.nights === 10) ? "disabled": ""}`} onClick={e => this.onNightsChange('up')}>
                    <span><svg className="nights inline-block" viewBox="0 0 25 25" role="img" aria-label="add" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect></svg></span>
                </button>
            </div>
        )
    }

    renderCalenderComponent(){
        
        const { departure_date, isLoading, product, currentBooking:{iso_currency} } = this.props;
        const { hasOptions } = productData(product, iso_currency);

        return (
            <div className="date-panel-calender margin-b-30">
                <CalenderPanel isBuilder={true} showProductlist={hasOptions}/>
                <div className="clearfix margin-t-20">
                    <div className="right col-12 sm-col-5">
                        <button
                            disabled={(departure_date === "" && !isLoading) ? true : false} 
                            className="busabout--cta orange rounded-corner full-width " 
                            onClick={this.onUpdate}>
                            { !isLoading && <>Update</> }
                            { isLoading && <ButtonSpinner/> }
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    onUpdate(){

        const { client, isLoading, currentBooking:{uuid, filteredItinerary}, currentStop, departure_date } = this.props;

        if(!isLoading){
            UpdateProductSector(client, uuid, parseInt(filteredItinerary[currentStop].id, 10), departure_date).then(()=>{
                this.setState({calenderIsOpen:false});
            });
        }
        
    }

    onChangeProductDate(){

        const { currentStop, currentBooking:{ filteredItinerary, iso_currency }, client } = this.props;
        const { productTourId } = itineraryListData(currentStop, filteredItinerary);
 
        this.setState({calenderIsOpen:!this.state.calenderIsOpen}, () => {
            if(this.state.calenderIsOpen){
                GetProduct(client, productTourId, iso_currency);
            }
        });
    }


    renderDayAndCalendarButtons(){

        const { changeNightVisible, nights, nightsTouched, calenderIsOpen } = this.state;
        const { currentStop, totalStops, currentBooking:{ filteredItinerary, status }, share } = this.props;
        const { isProduct } = itineraryListData(currentStop, filteredItinerary);

        //0 nights for first and last sector only
        const enableZeroNight = currentStop !== 0 && currentStop !== totalStops-1 && nights === 0;

        if((status !== "confirmed" && status !== "checkout" && !share) ){
            return (
                !isProduct ? (   
                    <button type="button" className={`rounded-svg-btn ${!changeNightVisible ? 'isChange' : 'isClose'}`} onClick={this.onChangeNight}>
                        { 
                            !changeNightVisible ? <><CalendarEditSvg clazz="mr1" />Change</> : 
                            !nightsTouched ? <CloseSvg /> : <CheckSvg clazz={`button checksvg ${enableZeroNight ? 'disabled' : ''}`} fill={"#ff6700"} onClickHandler={this.onCheckHandler}/> 
                        }
                    </button>
                    ) :
                    <button type="button" className={`rounded-svg-btn ${!calenderIsOpen ? 'isChange' : 'isClose'}`} onClick={this.onChangeProductDate}>
                        {!calenderIsOpen ? <><CalendarEditSvg clazz="mr1" />Change</> : <CloseSvg /> }
                    </button>
            )
        }else{
            return null;
        }


    }


    render(){
        const { changeNightVisible, showWarningModal, calenderIsOpen } = this.state;
        const { currentStop, currentBooking:{ filteredItinerary } } = this.props;

        let { 
            dateDurationStart: _dateDurationStart,
            dateDurationEnd: _dateDurationEnd,
            cityOrProductName: _currentCity
        } = itineraryListData(currentStop, filteredItinerary);


        return (
            <Fragment>
            <div className="clearfix margin-b-30">
                <div className={`col ${changeNightVisible ? 'col-2 sm-col-4' : 'col-1 md-col-1'}`}>
                    <CalendarSvg />
                    { changeNightVisible && <span className="bold uppercase f-size-16 xs-hide ml2">Duration</span>}
                </div>
                <div className={`col ${changeNightVisible ? 'col-10 sm-col-8' : 'col-11 md-col-11'}`}>
                <div className="inline">
                    {
                        !changeNightVisible ? <p className="medium inline"> {_dateDurationStart}{_dateDurationEnd} </p>
                        : this.renderNightComponent()
                    }
                </div>

                { this.renderDayAndCalendarButtons() }

                </div>
            </div>

            { calenderIsOpen && this.renderCalenderComponent() }            

            {
            
                <ReactModal
                    className="include-modal basket warning"
                    overlayClassName="modal-overlay semi-white"
                    isOpen={showWarningModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Include modal">
            
                    <div className="max-width-5 mx-auto clearfix">
                        <div className="col col-12 center">

                            <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                <path fill="currentColor" d="M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"></path>
                            </svg>

                            <h4 className="mb3 mt2">Are you sure?</h4>
                            <p className="medium margin-b-30">As a result of changing the length of stay in {_currentCity} all consequent link-up trip dates will change to next available departure. Link-up trips will be removed if there is no available departure within a 7 day period. </p>
                            
                
                            <button type="button" className="busabout--cta orange rounded-corner inline col-12 sm-col-5" onClick={this.closeModal}>Ok, I understand</button>
                    
                        </div>
                
                        <div className="col col-12 px2">
                            <button className="modal-close" onClick={this.closeModal}><CloseRoundSvg /></button>
                        </div>
                    </div>
                </ReactModal>
                
            }
            </Fragment>
        )
    }

}

const mapStateToProps = state => {
    return{
      currentBooking:state.currentBooking,
      isLoading:state.cart.update_sector_loading,
      departure_date:state.cart.departure_date,
      product:state.product
    }
}
  
export default withApollo(connect(mapStateToProps, null)(DatesNightsPanel)); 